import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface LocationState {
  country: string;
  lat: string;
  lon: string;
  currency: string;
}
// @ts-expect-error
const initialState: LocationState = (() => {
  if (typeof window !== "undefined") {
    const savedLocation = localStorage.getItem("location");
    return savedLocation
      ? JSON.parse(savedLocation)
      : { country: '', lat: '', lon: '', currency: '₹' };
  }
  return { country: '', lat: '', lon: '', currency: '₹' };
})();

const locationSlice = createSlice({
  name: 'location',
  initialState,
  reducers: {
    setLocationData: (state, action: PayloadAction<LocationState>) => {
      state.country = action.payload.country;
      state.lat = action.payload.lat;
      state.lon = action.payload.lon;
      state.currency = action.payload.currency;

      if (typeof window !== "undefined") {
        localStorage.setItem("location", JSON.stringify(action.payload));
      }
    },
  },
});

export const { setLocationData } = locationSlice.actions;
export default locationSlice.reducer;
